export default {
  "content": "<path fill=\"none\" d=\"M0 0h16v16H0z\"/><g fill=\"#fff\"><circle cx=\"8\" cy=\"12.5\" r=\"1.5\"/><path d=\"M8 7c-1.837 0-3.42.833-4.575 2.409a.999.999 0 101.612 1.182C5.812 9.536 6.809 9 8 9s2.188.535 2.963 1.591a1 1 0 001.612-1.184C11.419 7.833 9.837 7 8 7z\"/><path d=\"M15.831 7.161C14.084 4.556 11.19 3 8.091 3 5.081 3 2.125 4.654.181 7.426a1 1 0 101.638 1.148C3.388 6.336 5.733 5 8.091 5c2.432 0 4.704 1.224 6.079 3.274a.999.999 0 101.661-1.113z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 16 16"
  }
};